import { Store } from 'laco'
import { cookieStringToObject } from 'Helpers'

import AuthService from 'Services/auth'

const UserStore = new Store()

export async function updateUserStore() {
  const cookies = cookieStringToObject()

  UserStore.set(() => ({
    isLoggedIn: Boolean(cookies.loggedIn),
    virtualOffices: undefined,
    user: cookies.user,
    token: cookies.token
  }))
}

export async function login({ username, password }) {
  const response = await AuthService.login({
    username,
    password
  })
  updateUserStore()
  return response
}

export async function setupAccount({ username, password, inviteCode }) {
  const response = await AuthService.setupAccount({
    username,
    password,
    inviteCode
  })
  updateUserStore()
  return response
}

updateUserStore()

export default UserStore
